import { ReactComponent as DashboardIcon } from "src/assets/svg-icons/side-bar/dashboard.svg";
import { ReactComponent as AggregatorsIcon } from "src/assets/svg-icons/side-bar/aggregators.svg";
import { ReactComponent as ReportsIcon } from "src/assets/svg-icons/side-bar/reports.svg";
import { ReactComponent as OperationIcon } from "src/assets/svg-icons/side-bar/operation.svg";
import { ReactComponent as SettingsIcon } from "src/assets/svg-icons/side-bar/settings.svg";
import { ReactComponent as InventoryIcon } from "src/assets/svg-icons/side-bar/inventory.svg";
import { ReactComponent as MatchingIcon } from "src/assets/svg-icons/side-bar/matching.svg";
import { ReactComponent as MenuIcon } from "src/assets/svg-icons/side-bar/menu.svg";
import { ReactComponent as AuditingIcon } from "src/assets/svg-icons/side-bar/auditing.svg";
import { ReactComponent as PurchaseIcon } from "src/assets/svg-icons/side-bar/purchase.svg";
import { ReactComponent as EventIcon } from "src/assets/svg-icons/side-bar/event.svg";
import { ReactComponent as SalesIcon } from "src/assets/svg-icons/side-bar/sales.svg";
import { ReactComponent as BillIcon } from "src/assets/svg-icons/side-bar/bill.svg";

export const sideBarItems = [
  {
    label: "dashboard",
    icon: <DashboardIcon />,
    path: "/dashboard",
  },
  {
    label: "aggregators",
    icon: <AggregatorsIcon />,
    path: "/aggregators",
  },
  {
    label: "purchasing",
    icon: <PurchaseIcon />,
    path: "/purchasing",
  },
  {
    label: "operationExpenses",
    icon: <OperationIcon />,
    path: "/operation",
  },
  {
    label: "payroll",
    icon: <OperationIcon />,
    path: "/salary",
  },
  {
    label: "fixedAssets",
    icon: <BillIcon />,
    path: "/assets",
  },
  {
    label: "inventory",
    icon: <InventoryIcon />,
    path: "/inventory",
  },
  {
    label: "menu",
    icon: <MenuIcon />,
    path: "/menu",
  },
  {
    label: "sales",
    icon: <SalesIcon />,
    path: "/sales",
  },
  {
    label: "events",
    icon: <EventIcon />,
    path: "/events",
  },
  {
    label: "3rdEyeReport",
    icon: <ReportsIcon />,
    path: "/reports",
  },
  {
    label: "settings",
    icon: <SettingsIcon />,
    path: "/settings",
  },
  {
    label: "reconciliation",
    icon: <MatchingIcon />,
    path: "/matching",
  },
  {
    label: "auditing",
    icon: <AuditingIcon />,
    path: "/auditing",
  },
  {
    label: "forAccountant",
    icon: <AuditingIcon />,
    path: "/for-accountant",
  },
];
